import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
let RouteList = [{
        path: '/',
        component: resolve => require(['@/views/index.vue'], resolve),
        meta: {
            title: '首页',
            keepAlive: false,
        },
        children: [{
                path: '/',
                component: resolve => require(['@/views/home/index.vue'], resolve),
                meta: {
                    title: '全域旅游',
                    keepAlive: false,
                },

            },
            {
                path: '/all-tourism',
                component: resolve => require(['@/views/all-tourism/index.vue'], resolve),
                meta: {
                    title: '全域旅游',
                    keepAlive: false,
                },

            },
            {
                path: '/product-service',
                component: resolve => require(['@/views/product-service/index.vue'], resolve),
                meta: {
                    title: '产品与服务',
                    keepAlive: false,
                },

            },
            {
                path: '/customer-case',
                component: resolve => require(['@/views/customer-case/index.vue'], resolve),
                meta: {
                    title: '客户案例',
                    keepAlive: false,
                },

            },
            {
                path: '/about-us',
                component: resolve => require(['@/views/about-us/index.vue'], resolve),
                meta: {
                    title: '关于我们',
                    keepAlive: false,
                },

            },
            {
                path: '/wisdom-scenic',
                component: resolve => require(['@/views/wisdom-scenic/index.vue'], resolve),
                meta: {
                    title: '智慧景区',
                    keepAlive: false,
                },

            },
            {
                path: '/one-phone',
                component: resolve => require(['@/views/one-phone/index.vue'], resolve),
                meta: {
                    title: '一部手机游',
                    keepAlive: false,
                },

            },
            {
                path: '/one-phone',
                component: resolve => require(['@/views/one-phone/index.vue'], resolve),
                meta: {
                    title: '一部手机游',
                    keepAlive: false,
                },

            },
            {
                path: '/720vr',
                component: resolve => require(['@/views/720vr/index.vue'], resolve),
                meta: {
                    title: '720vr',
                    keepAlive: false,
                },

            },
            {
                path: '/touch-control',
                component: resolve => require(['@/views/touch-control/index.vue'], resolve),
                meta: {
                    title: '电子触控',
                    keepAlive: false,
                },

            },
            {
                path: '/big-data',
                component: resolve => require(['@/views/big-data/index.vue'], resolve),
                meta: {
                    title: '大数据',
                    keepAlive: false,
                },

            },
        ]
    },
    {
        path: '*',
        component: resolve => require(['@/views/404/index.vue'], resolve),
    }
]

export default new Router({
    routes: RouteList,
    mode: 'history'
})